// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__1GvwL","logo":"App_logo__3NbkX","header":"App_header__3sWa-","footer":"App_footer__Wh4Jv","list":"App_list__19oxd"};